// export const BASE_URL = 'http://localhost:3005'
export const BASE_URL = "https://internalapi.value360india.com"